import { useState, useRef } from 'react';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');
  const [charCount, setCharCount] = useState(0);
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setFormStatus('success');
      setFormMessage('投稿已提交，感谢你的爆料！');
      form.reset();
      setCharCount(0);
      return;
    }

    setFormStatus('loading');
    setFormMessage('');

    try {
      const formData = new FormData(form);
      if (honeypotEl) {
        formData.delete('phone_alt');
      }

      const response = await fetch('https://readdy.ai/api/form/d9lfbk4it35ii3jdl7eg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // not json
      }

      if (response.ok && parsed && (parsed as { code?: string }).code === 'OK') {
        setFormStatus('success');
        setFormMessage('投稿已提交，感谢你的爆料！我们会尽快审核处理。');
        form.reset();
        setCharCount(0);
      } else {
        const serverMsg =
          (parsed as { meta?: { message?: string; detail?: string }; message?: string })?.meta
            ?.message ||
          (parsed as { meta?: { message?: string; detail?: string }; message?: string })?.meta
            ?.detail ||
          (parsed as { message?: string })?.message ||
          responseText;
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormStatus('error');
          setFormMessage('提交失败，请稍后重试。');
        } else {
          setFormStatus('error');
          setFormMessage(serverMsg || '提交失败，请稍后重试。');
        }
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            联系我们
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            有料要爆？有瓜要分享？欢迎随时向我们投稿
          </p>
          <div className="bg-background-50 rounded-2xl p-6 md:p-8">
            <form
              ref={formRef}
              data-readdy-form
              onSubmit={handleSubmit}
              className="space-y-4"
            >
              <input
                type="text"
                name="phone_alt"
                className="honeypot-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />

              <div>
                <label className="block text-sm font-medium text-foreground-800 mb-1.5">
                  你的昵称
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  placeholder="吃瓜群众"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground-800 mb-1.5">
                  联系邮箱
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  placeholder="your@email.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground-800 mb-1.5">
                  爆料内容
                  <span className="text-xs text-foreground-500 ml-2">
                    {charCount}/500
                  </span>
                </label>
                <textarea
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  onChange={(e) => setCharCount(e.target.value.length)}
                  className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                  placeholder="请详细描述你想分享的瓜……"
                />
              </div>

              <button
                type="submit"
                disabled={formStatus === 'loading'}
                className="w-full py-3 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-white font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                {formStatus === 'loading' ? (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-loader-4-line animate-spin"></i>
                    提交中...
                  </span>
                ) : (
                  '提交爆料'
                )}
              </button>

              {formStatus === 'success' && formMessage && (
                <div className="p-3 bg-secondary-100 border border-secondary-200 rounded-lg">
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-secondary-600"></i>
                    <p className="text-sm text-secondary-800">{formMessage}</p>
                  </div>
                </div>
              )}

              {formStatus === 'error' && formMessage && (
                <div className="p-3 bg-primary-100 border border-primary-200 rounded-lg">
                  <div className="flex items-center gap-2">
                    <i className="ri-error-warning-line text-primary-600"></i>
                    <p className="text-sm text-primary-800">{formMessage}</p>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}